import { Container, Row, Col } from 'react-bootstrap';
import Skip2Submit from './Skip2Submit';
import SubmissionsTextContent from "./SubmissionsTextContent";
import "./SubmissionsContentLayout.css";

const SubmissionsContentLayout = (props) => {

  return(
    <div id="submissions-content-layout-wrapper">
      <Container fluid id="submissions-content-layout">
        <Row className="submissions-layout-row">
          <Col 
            id="submissions-cards"
            xs={12} 
            sm={12}
            md="auto" 
            lg="auto"
          >
            <div id="submissions-cards-sticky-box">
              <Row>
                <Col className="col-no-pad">
                  <Skip2Submit/>
                </Col>
              </Row>
            </div>
          </Col>
          <Col 
            id="submissions-content" 
            xs={12}
            sm={12} 
            md={7} 
            lg={9}
          >
            <Row>
              <Col id="submissions-layout-text-content-wrapper">
                <SubmissionsTextContent/>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SubmissionsContentLayout;
